import type { QueryClient } from '@tanstack/react-query';
import type { Project } from '../../../types';

const PROJECT_RELATED_QUERY_KEYS = [
  ['projects'],
  ['project-detail'],
  ['my-entries'],
  ['my-calendar'],
  ['my-entries-for-day'],
  ['admin-entries'],
  ['approvals-queue'],
] as const;

export function getErrorMessage(error: unknown, fallback: string): string {
  return (error as any)?.response?.data?.error || fallback;
}

export function refreshProjectRelatedQueries(queryClient: QueryClient, updatedProject: Project) {
  queryClient.setQueryData<Project[]>(['projects'], (projects) =>
    projects?.map((project) => project.id === updatedProject.id ? updatedProject : project),
  );

  return Promise.all(
    PROJECT_RELATED_QUERY_KEYS.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
}
